import CreateForm from '@/pages/host/CreateForm'
import UpdateForm from '@/pages/host/UpdateForm'
import DeleteForm from '@/pages/host/DeleteForm'
import Collection from '@/components/Collection'
import access from "../access";
import History from '@/pages/event/Detail';

const hostNs = "urn:ietf:params:xml:ns:host-1.0";

export default {

  'host.collection': {
    path: '/admin/hosts',
    name: 'host.collection',
    component:  Object.assign({}, Collection), // https://stackoverflow.com/a/41425312
    props: {
      handler: "listHosts",
      entity: "host",
      cols: [
        { label: "Name", sort: "name", field: "name" },
        { label: "IPs", html: (row) => (row && row.ips instanceof Array) ? row.ips.join('<br>') : null },
        {
          label: "Owner",
          sort: "registrar",
          component: "RouteLabelConverter",
          componentProps: (row) => {
            return {
              request: {registrar_id: row.registrar},
              placeholder: row.registrar,
              call: "viewRegistrar",
              handler: function(data) {
                return data.name + ", " + data.org;
              },
              route: {
                to: {
                  name: "registrar.view",
                  params: {
                    id: row.registrar,
                  },
                },
              }
            };
          },
        },
        { label: "Creator", sort: "creator_rid", field: "creator_rid" },
        { label: "Created", sort: "created_at", field: "created_at", date: "date" },
        { label: "Updated", sort: "updated_at", field: "updated_at", date: "date" },
        { label: "Transferred", sort: "transfer_at", field: "transfer_at", date: "date" },
        { label: "Status", html: (row) => (row && row.status instanceof Array) ? row.status.join('<br>') : null },
      ],
      actions: (rec) => {
        return [
          { name: "host.update", label: "edit", icon: "pencil2", params: {name: rec.name} },
          { name: "host.delete", label: "delete", icon: "bin", params: {name: rec.name} },
        ];
      }
    },
    meta: {
      access: access.chain(access.authenticated, access.service(hostNs)),
      title: "Host list",
      side_menu: { label: "Hosts",  icon: "tree" },
      local_actions: [
        { name: "host.create", label: "Create host", color: "success", icon: "plus" }
      ]
    },
  },

  'host.create': {
    path: '/admin/hosts/create',
    name: 'host.create',
    component: CreateForm,
    meta: {
      title: "Create new host"
    },
  },

  'host.history': {
    path: '/admin/hosts/history/:name',
    name: 'host.history',
    component: History,
    props: (route) => {
      return {
        domain: "epp",
        type: "host",
        id: route.params.name,
      }
    },
    meta: {
      access: access.chain(access.admin, access.service(hostNs)),
      title: "View history of changes",
      local_tasks: [
        { name: "host.history", label: "History"},
        { name: "host.update", label: "Edit"},
        { name: "host.delete", label: "Delete"}
      ]
    },
  },

  'host.update': {
    path: '/admin/hosts/update/:name',
    name: 'host.update',
    component: UpdateForm,
    props: true,
    meta: {
      access: access.chain(access.authenticated, access.service(hostNs)),
      title: "Update host details",
      local_tasks: [
        { name: "host.history", label: "History"},
        { name: "host.update", label: "Edit"},
        { name: "host.delete", label: "Delete"}
      ]
    },
  },

  'host.delete': {
    path: '/admin/hosts/delete/:name',
    name: 'host.delete',
    component: DeleteForm,
    props: true,
    meta: {
      access: access.chain(access.authenticated, access.service(hostNs)),
      title: "Delete host",
      local_tasks: [
        { name: "host.history", label: "History"},
        { name: "host.update", label: "Edit"},
        { name: "host.delete", label: "Delete"}
      ]
    },
  },

}



// WEBPACK FOOTER //
// ./src/routes/modules/host.js